import React from 'react';

import Icon from '@ant-design/icons';

const GiftsAtDeviceIconSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="18"
    viewBox="0 0 22 18"
    fill="currentColor"
  >
    <path
      d="M17 14H15C14.7167 14 14.4793 13.904 14.288 13.712C14.0967 13.52 14.0007 13.2827 14 13C13.9993 12.7173 14.0953 12.48 14.288 12.288C14.4807 12.096 14.718 12 15 12H17V10C17 9.71667 17.096 9.47933 17.288 9.288C17.48 9.09667 17.7173 9.00067 18 9C18.2827 8.99933 18.5203 9.09533 18.713 9.288C18.9057 9.48067 19.0013 9.718 19 10V12H21C21.2833 12 21.521 12.096 21.713 12.288C21.905 12.48 22.0007 12.7173 22 13C21.9993 13.2827 21.9033 13.5203 21.712 13.713C21.5207 13.9057 21.2833 14.0013 21 14H19V16C19 16.2833 18.904 16.521 18.712 16.713C18.52 16.905 18.2827 17.0007 18 17C17.7173 16.9993 17.48 16.9033 17.288 16.712C17.096 16.5207 17 16.2833 17 16V14ZM2 18C1.45 18 0.979333 17.8043 0.588 17.413C0.196667 17.0217 0.000666667 16.5507 0 16V2C0 1.45 0.196 0.979333 0.588 0.588C0.98 0.196667 1.45067 0.000666667 2 0H16C16.55 0 17.021 0.196 17.413 0.588C17.805 0.98 18.0007 1.45067 18 2V6C18 6.28333 17.904 6.521 17.712 6.713C17.52 6.905 17.2827 7.00067 17 7C16.7173 6.99933 16.48 6.90333 16.288 6.712C16.096 6.52067 16 6.28333 16 6V5H2V16H14C14.2833 16 14.521 16.096 14.713 16.288C14.905 16.48 15.0007 16.7173 15 17C14.9993 17.2827 14.9033 17.5203 14.712 17.713C14.5207 17.9057 14.2833 18.0013 14 18H2ZM2 3H16V2H2V3Z"
      fill="currentColor"
    />
  </svg>
);
const GiftsAtDeviceIcon = props => {
  return <Icon component={GiftsAtDeviceIconSvg} {...props} />;
};
export default GiftsAtDeviceIcon;
